import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'

import {Stack, List, ListItem, Text, Heading} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'

// Others
import {noop} from '@salesforce/retail-react-app/app/utils/utils'

const SiblingCategories = ({categories = [], onSelect = noop}) => {
    if (categories.length === 0) {
        return null
    }

    return (
        <Stack spacing={[24, 24, 24, 20]}>
            <Text as="h2" textStyle="eyeBrowSmall" textTransform="uppercase">
                <FormattedMessage
                    defaultMessage="Also discover:"
                    id="product_list.sibling_categories.heading"
                />
            </Text>

            {/* Print 4 links only */}
            <List
                display="flex"
                flexWrap="wrap"
                rowGap={[20, 20, 20, 10]}
                columnGap={['45px', '45px', '45px', 70]}
            >
                {categories?.slice(0, 4).map(({id, displayName}) => {
                    return (
                        <ListItem key={id}>
                            <Heading as="h3">
                                <Link href={`/category/${id}`} onClick={onSelect} useNavLink>
                                    {displayName}
                                </Link>
                            </Heading>
                        </ListItem>
                    )
                })}
            </List>
        </Stack>
    )
}

SiblingCategories.propTypes = {
    categories: PropTypes.array,
    onSelect: PropTypes.func
}

export default SiblingCategories
